import { Box, Button, Typography } from '@mui/material';
import type { PopperProps } from '@mui/material/Popper';
import Popper from '@mui/material/Popper';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';

export interface TooltipPopperProps {
  open: boolean;
  anchorEl: PopperProps['anchorEl'];
  onClose: () => void;
  title?: ReactNode;
  description?: ReactNode;
  placement?: PopperProps['placement'];
  hideLabel?: string;
  sx?: SxProps<Theme>;
  actions?: ReactNode;
  children?: ReactNode;
}

export default function TooltipPopper({
  open,
  anchorEl,
  onClose,
  title,
  description,
  placement = 'top-start',
  hideLabel = 'Hide these tips',
  sx,
  actions,
  children,
}: TooltipPopperProps) {
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement={placement}
      disablePortal
      sx={{ zIndex: 99999, ...sx }}
      modifiers={[{ name: 'offset', options: { offset: [8, 8] } }]}
    >
      <Box sx={{ borderRadius: 1, backgroundColor: '#383838' }}>
        <Box sx={{ padding: 4, maxWidth: 400 }}>
          {children ? (
            children
          ) : (
            <Box sx={{ color: '#fff' }}>
              {title && (
                <Typography
                  variant='body1'
                  sx={{
                    fontWeight: 600,
                  }}
                >
                  {title}
                </Typography>
              )}
              {description && (
                <Typography variant='body2' sx={{ mt: 2 }}>
                  {description}
                </Typography>
              )}
            </Box>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 4,
          }}
        >
          {actions ?? (
            <Button sx={{ color: '#fff', fontSize: '12px' }} onClick={onClose}>
              {hideLabel}
            </Button>
          )}
        </Box>
      </Box>
    </Popper>
  );
}
